import React from 'react';

const OkMessage = ({ text }) => {
  return (
    <div className="settings-text-helper ok-message">
      <p>✅ {text}</p>
    </div>
  );
};

export default OkMessage;
